'use client';

import { useSyncExternalStore } from 'react';
export const usePrefersReducedMotion = () => {
  const getPrefersReducedMotion = _temp;
  return useSyncExternalStore(_temp2, getPrefersReducedMotion, _temp3);
};
function _temp() {
  return typeof window !== "undefined" ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
}
function _temp2(callback) {
  const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  mediaQuery.addEventListener("change", callback);
  return () => mediaQuery.removeEventListener("change", callback);
}
function _temp3() {
  return false;
}